import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Relationship } from '../../../models/relationship';

import { ModalService } from '../../../services/common/modal.service';
import { NotyService } from '../../../services/common/noty.service';
import { RelationshipService } from '../../../services/contacts/relationship.service';

@Component({
  selector: 'app-contact-relationships',
  templateUrl: './contact-relationships.component.html',
  styleUrls: ['./contact-relationships.component.scss'],
})
export class ContactRelationshipsComponent implements OnInit, OnChanges {
  /**
   * Id of contact
   */
  @Input() contactId: number;

  formOptions: any = {
    relationship_types: [],
  };

  /**
   * Indicates if relationships are loading
   * @type {boolean}
   */
  loadingRelationships: boolean = true;

  /**
   * New relationship object
   */
  newRelationship: Relationship = new Relationship();

  /**
   * List of contact relationships
   * @type {Array<Relationship>}
   */
  relationships: Array<Relationship> = [];

  /**
   * Indicates if new relationship form is to be shown
   * @type {boolean}
   */
  showNewRelationshipForm: boolean = false;

  /**
   * Inject services
   * @param {ModalService}        private modalService        Display confirm modals
   * @param {NotyService}         private notyService         Notifications
   * @param {RelationshipService} private relationshipService Service for Relationship resource
   */
  constructor(private modalService: ModalService, private notyService: NotyService, private relationshipService: RelationshipService) {
    this.relationshipService.formOptions().then((response_json) => {
      this.formOptions = response_json;
      this.newRelationship.relation_id = this.formOptions.relationship_types[0].value;
    });
  }

  // Component lifecycle methods
  ngOnInit() {}

  /**
   * Called when variables of the component change
   * @param {SimpleChanges} changes Object with changed variables of the component
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) {
      this.newRelationship.contact_id = this.contactId;
      this.loadRelationships();
    }
  }

  // Component methods

  /**
   * Delete Relationship
   * @param {Relationship} relationship Relationship to delete
   * @param {number}       index        Position of relationship
   */
  deleteRelationship(relationship: Relationship, index: number) {
    this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-danger';
    this.modalService.confirmDialogComponent.open(`<p>Delete Relationship - <strong class='text-danger'>${relationship.role} ${relationship.name}</strong></p>`).result.then(
      (result) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
        if (result == 'confirmed') {
          this.relationshipService
            .delete(relationship.id)
            .then((response_json) => {
              if (response_json.success) {
                this.notyService.notify(response_json.text || 'Relationship removed', 'info', 5000, 'topRight');
                this.loadRelationships();
              } else this.notyService.notify(response_json.text || 'Error removing relationship', 'error', 5000, 'topRight');
            })
            .catch(() => {
              this.notyService.notify('Error removing relationship', 'error', 5000, 'topRight');
            });
        }
      },
      (reason) => {
        this.modalService.confirmDialogComponent.confirmButtonClasses = 'btn btn-primary';
      }
    );
  }

  /**
   * Load relationships for contact
   */
  loadRelationships() {
    this.loadingRelationships = true;
    this.relationshipService.index({ contact_id: this.contactId }).then((response_json) => {
      this.relationships = response_json;
      this.loadingRelationships = false;
    });
  }

  /**
   * Save relationship
   * @param {Relationship} relationship Relationship to be saved
   */
  saveRelationship(relationship: Relationship) {
    relationship.formSubmitted = true;
    if (!relationship.related_id || !relationship.relation_id) {
      this.notyService.notify('Please check form again', 'warning', 5000, 'topRight');
      return;
    }
    relationship.formSubmitting = true;
    this.relationshipService
      .save(relationship)
      .then((response_json) => {
        relationship.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Relationship saved', 'success', 5000, 'topRight');
          this.loadRelationships();
          if (relationship.id) relationship.editing = false;
          else {
            this.showNewRelationshipForm = false;
            this.newRelationship = new Relationship();
            this.newRelationship.contact_id = this.contactId;
            this.newRelationship.relation_id = this.formOptions.relationship_types[0].value;
          }
        } else this.notyService.notify(response_json.text || 'Error saving relationship', 'error', 5000, 'topRight');
      })
      .catch(() => {
        relationship.formSubmitting = false;
        this.notyService.notify('Error saving relationship', 'error', 5000, 'topRight');
      });
  }
}
